import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";
import { initSentry } from "./lib/sentry";

// Initialise error tracking (no-ops if VITE_SENTRY_DSN is not set)
initSentry();

// Initialise PostHog analytics (no-ops if VITE_POSTHOG_KEY is not set)
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
